/**
 * Base event type. All domain events extend this.
 * The event name is the discriminator — properties are typed per-event.
 */
export interface AnalyticsEvent<
    TName extends string = string,
    TProperties extends Record<string, unknown> = Record<string, unknown>,
> {
    name: TName;
    properties: TProperties;
}

/**
 * Helper to define an event factory.
 * Returns a function that produces a typed { name, properties } object.
 */
export function defineEvent<
    TName extends string,
    TProperties extends Record<string, unknown>,
>(name: TName) {
    return (properties: TProperties): AnalyticsEvent<TName, TProperties> => ({
        name,
        properties,
    });
}
